import { BadRequestError } from '@cian/valuation-utils-component';

import { TThunkAction } from '../../types/redux';
import { failureAction, requestAction, successAction } from './actions';
import {
  fetchGetEstimationHistoryByDealTypeWeb,
  IGetEstimationHistoryByDealTypeWebRequest,
  IGetEstimationHistoryByDealTypeWebResponse,
  IGetEstimationHistoryByDealTypeWebResponse200 as IRes200,
  IGetEstimationHistoryByDealTypeWebResponse400 as IRes400,
} from '../../repositories/price-estimator/v1/get-estimation-history-by-deal-type-web';
import { selectApiParameters } from '../../selectors/estimation';
import { selectDealType } from '../../selectors/page';

export const getEstimationChartData =
  (): TThunkAction<Promise<IGetEstimationHistoryByDealTypeWebResponse | Error>> => async (dispatch, getState, ctx) => {
    const state = getState();
    const dealType = selectDealType(state);

    dispatch(requestAction());

    const parameters: IGetEstimationHistoryByDealTypeWebRequest = {
      ...selectApiParameters(state),
      dealType,
    };

    try {
      const res = await fetchGetEstimationHistoryByDealTypeWeb<IRes200, IRes400>({
        httpApi: ctx.httpApi,
        parameters,
      });

      if (res.statusCode !== 200) {
        throw new BadRequestError({
          domain: 'getEstimationChartData.ts',
          message: res.response.message as string,
          details: { errors: JSON.stringify(res.response.errors) },
        });
      }

      dispatch(successAction(res.response.data || null));

      return res.response;
    } catch (e) {
      dispatch(failureAction());

      if (!(e instanceof BadRequestError)) {
        ctx.logger.error(e, {
          message: 'Ошибка при загрузке данных',
          domain: 'getEstimationChartData.ts',
          parameters: JSON.stringify(parameters),
        });
      }

      return e as Error;
    }
  };
